<div class="boost-info-container">
  <div class="close-header" (click)="onNoClick()">x</div>
  <div class="boost-icon-container">
    <image-loader-utils url="freebet" extraClasses="freebet-svg" imageFormat="png"></image-loader-utils>
  </div>
  <div class="header-bold">{{ 'freebet' | translate }}</div>
  <div class="text-row">{{ 'freebet_bonus_modal_description' | translate }}</div>

  <div class="boost-info-detail-container">
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_5' | translate }} {{ this._DataHelper.customerFreeBetBonusInfo.MinOddValue | oddFormat }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'boost_bonus_modal_6' | translate }} {{ this._DataHelper.customerFreeBetBonusInfo.MaxOddValue | oddFormat }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'min_events' | translate }} {{ this._DataHelper.customerFreeBetBonusInfo.MinEventCount }}
    </div>
    <div class="info-detail-item">
      <div class="dot"></div>

      {{ 'Exp_Date' | translate }} {{ this._DataHelper.customerFreeBetBonusInfo.EndDate | dateFormat : 'dd.MM.yy' }}
    </div>

    <div class="color-blue" (click)="openInNewTab('/banner/bonus-de')">
      {{ 'terms_and_conditions' | translate }}
    </div>
  </div>

  <ng-container *ngIf="!this._DataHelper.freebetBonusCheckBox; else disabledButton">
    <div class="button-container" (click)="setFreeBetCheckBox()">
      <div class="btn colored green save-changes-button confirm-button">
        <div class="btn-text">
          {{ 'freebet_bonus_modal_1' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #disabledButton>
    <div class="disabled button-container">
      <div class="btn colored green save-changes-button confirm-button">
        <div class="btn-text">
          {{ 'freebet_bonus_modal_1' | translate }}
        </div>
      </div>
    </div>
  </ng-template>
</div>
